import { useFarm } from '../contexts/farms';
import KpiStats from '../../kpis/layouts/kpi-stats';

// Estadísticas de una finca: KPIs del dashboard acotados por farm_id (admin-kpis.md).
export default function FarmStats({ farmId }) {
    const { data: farm } = useFarm(farmId);
    return (
        <KpiStats
            scope={{ farm_id: farmId }}
            title={farm?.name ? `Finca · ${farm.name}` : 'Finca'}
            subtitle="Indicadores reproductivos de la finca."
            backTo="/admin/farms"
            backLabel="Fincas"
        />
    );
}
